module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-down-gray-medium-edd80c3666324c604ff0292afb8d0981.png";